import { Maximize2, Minimize2, X } from 'lucide-react'

interface PanelToolbarProps {
  title: string
  icon?: React.ReactNode
  isMaximized?: boolean
  onMaximize?: () => void
  onClose?: () => void
  closeable?: boolean
  extra?: React.ReactNode
}

export default function PanelToolbar({
  title,
  icon,
  isMaximized,
  onMaximize,
  onClose,
  closeable = true,
  extra,
}: PanelToolbarProps) {
  return (
    <div className="flex items-center justify-between px-3 py-2 bg-background border-b border-border h-10 flex-shrink-0">
      <div className="flex items-center gap-2 min-w-0">
        {icon && <span className="text-muted-foreground flex-shrink-0">{icon}</span>}
        <span className="text-sm font-medium truncate">{title}</span>
      </div>
      <div className="flex items-center gap-1">
        {extra}
        {onMaximize && (
          <button
            onClick={onMaximize}
            className="p-1 rounded hover:bg-background transition-colors"
            title={isMaximized ? 'Restore' : 'Maximize'}
          >
            {isMaximized ? (
              <Minimize2 className="w-3.5 h-3.5" />
            ) : (
              <Maximize2 className="w-3.5 h-3.5" />
            )}
          </button>
        )}
        {closeable && onClose && (
          <button
            onClick={onClose}
            className="p-1 rounded hover:bg-destructive/20 hover:text-destructive transition-colors"
            title="Close panel"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
    </div>
  )
}
